import {MenuItemRendererProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/MainMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./LinkMenuItemRenderer.less');
const cx = classnames.bind(styles);

@observer
export class LinkMenuItemRenderer extends React.Component<MenuItemRendererProps, any>
{
    render()
    {
        const {menuItem} = this.props;

        // use id as href source to not create any additional abstractions for menuItem
        return <a className={cx('menuItem')} href={menuItem.id}>
            {menuItem.title}
        </a>;
    }
}
